import type { WorkflowStatusId } from 'types/workflow/workflow-status';
import { WORKFLOW_STATUS_IDS } from 'types/workflow/workflow-status';
import type UserConfigModel from 'types/userConfig/userConfig';

export function getDefaultNotificationPreferences(): NonNullable<UserConfigModel['notificationPreferences']> {
  const workflowStatus: Partial<Record<WorkflowStatusId, boolean>> = {};
  for (const id of WORKFLOW_STATUS_IDS) workflowStatus[id] = true;
  return {
    workflowStatus,
    notifyOnNoteInMyChat: true,
    notifyOnTaggedInNote: true,
  };
}

export function mergeNotificationPreferences(
  prefs: UserConfigModel['notificationPreferences'] | undefined,
): NonNullable<UserConfigModel['notificationPreferences']> {
  const d = getDefaultNotificationPreferences();
  if (!prefs) return d;
  return {
    ...d,
    ...prefs,
    workflowStatus: { ...d.workflowStatus, ...prefs.workflowStatus },
    notifyOnNoteInMyChat: prefs.notifyOnNoteInMyChat ?? d.notifyOnNoteInMyChat,
    notifyOnTaggedInNote: prefs.notifyOnTaggedInNote ?? d.notifyOnTaggedInNote,
  };
}

/** resolvedFlowStatus — flowStatusCode מהאובייקט או מרשימת השיחות ב־Redux (מחושב בקריאה) */
export function shouldDeliverGeneralNotification(
  prefs: UserConfigModel['notificationPreferences'] | undefined,
  messageObject: {
    flowStatusCode?: WorkflowStatusId | null;
    notificationEvent?: string;
    eventKind?: string;
    isInternalNote?: boolean;
  },
  resolvedFlowStatus?: WorkflowStatusId | null,
): boolean {
  const m = mergeNotificationPreferences(prefs);
  const kind = messageObject.notificationEvent ?? messageObject.eventKind;
  const noteLike =
    kind === 'note' ||
    kind === 'internal_note' ||
    kind === 'InternalNote' ||
    messageObject.isInternalNote === true;

  if (noteLike) {
    return m.notifyOnNoteInMyChat !== false;
  }

  const fs = messageObject.flowStatusCode ?? resolvedFlowStatus;
  if (fs == null || fs === undefined) return true;
  return m.workflowStatus?.[fs] !== false;
}

export function shouldDeliverTaggedNoteNotification(
  prefs: UserConfigModel['notificationPreferences'] | undefined,
): boolean {
  return mergeNotificationPreferences(prefs).notifyOnTaggedInNote !== false;
}
